import { useFormContext } from "react-hook-form";
import { mutate } from "swr";

import CeuGoalsFields from "./fields/CeuGoalsFields";
import { ceuSelectedIds } from "./fields/preferencesValidation";
import OnboardingWizardStepFooter from "./OnboardingWizardStepFooter";
import OnboardingWizardStepHeader from "./OnboardingWizardStepHeader";
import type { WizardFormValues } from "./onboardingWizardForm";
import useOnboardingTracking from "./useOnboardingTracking";
import { useWizardMode } from "./WizardModeContext";
import { useOnboarding } from "~/hooks";

const OnboardingWizardStepCeuGoals = () => {
	const { handleUpdate, setStep } = useOnboarding();
	const { mode } = useWizardMode();
	const { track } = useOnboardingTracking();
	const { watch } = useFormContext<WizardFormValues>();

	const ceuGoals = watch("ceuGoals");
	const selectedIds = ceuSelectedIds({ ceuGoals });

	const handleNext = async () => {
		if (mode === "live") {
			const goals = selectedIds.map((accreditationId) => {
				const { renewalDate } = ceuGoals[accreditationId] ?? {};
				return {
					accreditationId,
					renewalDate: renewalDate ? new Date(renewalDate).toISOString() : null,
				};
			});
			await handleUpdate({ ceuGoals: goals });
			await mutate("/users/ceu-goals");
		}
		track("onboarding:step_completed", {
			accreditation_ids: selectedIds,
			accreditation_count: selectedIds.length,
		});
		setStep(mode === "deferred" ? "auth" : "phone");
	};

	return (
		<div className="flex h-full min-h-0 flex-1 flex-col gap-4 phablet:gap-6">
			<OnboardingWizardStepHeader
				title="Which boards do you need credits for?"
				subtitle="Select the boards you need CE credits for."
			/>

			<div className="flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto pr-1">
				<CeuGoalsFields />
			</div>

			<OnboardingWizardStepFooter
				note={`${selectedIds.length} board${selectedIds.length !== 1 ? "s" : ""} selected`}
				primary={{ onClick: handleNext, disabled: selectedIds.length === 0 }}
			/>
		</div>
	);
};

export default OnboardingWizardStepCeuGoals;
